var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSingleStaricon = function SvgSingleStaricon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a.7.7 0 0 1 .673.508l.759 2.656a3.5 3.5 0 0 0 .89 1.514c.421.42 1.514.89 1.514.89l2.657.76a.7.7 0 0 1 0 1.345l-2.657.759a3.5 3.5 0 0 0-2.404 2.404l-.759 2.657a.7.7 0 0 1-1.346 0l-.759-2.657a3.5 3.5 0 0 0-2.404-2.404l-2.657-.759a.7.7 0 0 1 0-1.346l2.657-.759a3.5 3.5 0 0 0 2.404-2.404l.759-2.656A.7.7 0 0 1 8 1Z",
    clipRule: "evenodd"
  })));
};
export default SvgSingleStaricon;